module.exports = __webpack_public_path__ + "media/images/holidaybox/bg-lg-ec85ac5a99ec10d2a6a2d57d5654269e.jpg";